import InfoBox from './info-box';

export default InfoBox;
